<template>
  <div class="container" v-loading="loading">
    <div class="messageWrap">
      <!-- 交易代码 -->
      <p class="messageTitle">{{ $t("payment.transactionNo") }}</p>
      <div class="pt14">
        <p class="fs14">{{ orderDetail.transactionCode }}</p>
      </div>
    </div>
    <div class="pt30 messageWrap" v-if="orderDetail.country">
      <!-- 拟设公司所在地 -->
      <p class="messageTitle">{{ $t("creation.locationTitle") }}</p>
      <div class="pt14 fs14">
        {{ getGlobalLabel("supportServiceCountryList", orderDetail.country) }}
      </div>
    </div>
    <div class="pt30 messageWrap">
      <!-- 待支付订单 -->
      <p class="messageTitle">{{ $t("notPaid.notPaid") }}</p>
      <div class="pt20">
        <el-table :data="tableData" header-cell-class-name="table-header">
          <template slot="empty">
            <div class="placeholderWrap">
              <img src="@/assets/img/placeholder02.png" alt="" />
              <!-- 订单查询中 -->
              <p class="fxRow emptyTipe" v-if="updateTipe == 1">
                <span class="fs16 mr6 el-icon-loading"></span>
                {{ $t("common.placeholder.inquiryOrder") }}
              </p>
              <!-- 暂无订单 -->
              <p class="emptyTipe" v-if="updateTipe == 2">
                {{ $t("common.placeholder.noOrder") }}
              </p>
            </div>
          </template>
          <el-table-column :label="$t('notPaid.paymentDueDate')" prop="paymentDueTime" align="center" width="176px" />
          <el-table-column :label="$t('notPaid.amountUnpaid')" align="center" min-width="160px">
            <template slot-scope="scope">
              <p class="fwb orange">{{ priceCurrencyFormat(scope.row.invoiceInfo?.totalAmount, scope.row.invoiceInfo?.billingCurrency) }}</p>
              <p class="fs12 gray" v-if="$isNumberLike(scope.row.invoiceInfo?.taxAmount)">
                ({{ $t("notPaid.taxIncluded") }} {{ priceCurrencyFormat(scope.row.invoiceInfo?.taxAmount, scope.row.invoiceInfo?.billingCurrency) }})
              </p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('notPaid.description')" prop="description" align="center" min-width="180px" />
          <el-table-column :label="$t('notPaid.billingParty')" prop="billingParty" align="center" min-width="140px" />
          <el-table-column :label="$t('notPaid.status')" align="center" min-width="140px">
            <template slot-scope="scope">
              <p>{{ getGlobalLabel("orderStatusList", scope.row.status) }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('notPaid.invoice')" align="center" width="132px">
            <template slot-scope="scope">
              <!-- 普通发票 -->
              <p>
                <router-link :to="`/invoice?invoiceNo=${scope.row?.invoiceInfo?.invoiceNumber}`" target="_blank" class="blueDark" v-if="scope.row?.invoiceInfo?.invoiceNumber">
                  {{ $t("invoice.common.generalInvoice") }}
                </router-link>
              </p>
              <!-- 退款发票列表 -->
              <el-dropdown v-if="scope.row?.refundedInvoiceInfoList?.length > 0" trigger="hover" popper-class="refundedInvoiceDropdown" @command="toRefundedInvoice">
                <span class="blueDark">
                  {{ $t("invoice.common.creditInvoice") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in scope.row.refundedInvoiceInfoList.filter(i => i.invoiceNumber)"
                    :key="`refundedInvoiceInfo-${scope.$index}-${item.id}`"
                    :command="item.invoiceNumber"
                  >
                    {{ item.businessNo ? `${item.businessNo} / ` : "" }}{{ item.invoiceNumber }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <el-table-column align="center" :label="$t('common.operation')" width="126px">
            <template slot-scope="scope">
              <!-- 待付款、部分付款 可以去支付 -->
              <template v-if="scope.row.status == 'UNPAID' || scope.row.status == 'PARTLY_PAID'">
                <el-button type="text" icon="el-icon-bank-card" class="mr6" @click="payment(scope.row)">
                  {{ $t("notPaid.payment") }}
                </el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction } from "@/api/common";
import formatMixin from "@/mixins/formatMixin";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "EnrollNotPaid",
  mixins: [formatMixin],
  inject: ["reload"],
  data() {
    return {
      applymentId: null, // 申请单id
      adjustmentId: null, // 补款单id
      orderDetail: {}, // 订单详情
      tableData: [], // 订单列表
      updateTipe: null, // 待支付订单列表为空时的提示类型
      timerst: null, // 定时器
      timerstNum: 0, // 定时器触发次数
      loading: true,
    };
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
    ...mapGetters("constant", ["getGlobalLabel"]),
  },
  methods: {
    ...mapActions("applyment", ["fetchApplymentDetail"]),
    // 页面初始化数据整理
    async pageInit(type) {
      try {
        this.loading = true;
        if (type == 1) {
          // 获取申请详情
          const resData = await this.fetchApplymentDetail(this.applymentId);
          this.orderDetail = {
            businessType: resData.businessType,
            businessId: resData.id,
            transactionCode: resData.applymentNo,
            country: resData.country,
          };
        } else {
          // 获取补款单(Quotation V)详情
          const resData = await this.getQuotationVDetail();
          this.orderDetail = {
            businessType: "ADJUSTMENT",
            businessId: resData.id,
            transactionCode: resData.adjustmentNo,
            country: null,
          };
        }
        // 获取订单列表
        await this.getOrderList();
        // 开始轮询
        this.startPolling();
      } catch (err) {
        this.clearTimer();
        this.updateTipe = 2;
      } finally {
        this.loading = false;
      }
    },
    // 获取补款单详情
    getQuotationVDetail() {
      return new Promise((resolve, reject) => {
        getAction(`/adjustment/${this.adjustmentId}/detail`)
          .then(res => {
            const resData = res.data || {};
            resolve(resData);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取订单列表
    getOrderList() {
      return new Promise((resolve, reject) => {
        getAction("/order/getOrderList", {
          businessType: this.orderDetail.businessType,
          businessId: this.orderDetail.businessId,
        })
          .then(res => {
            const resData = res.data || [];
            this.tableData = resData;
            if (this.tableData.length > 0) {
              this.clearTimer();
            }
            resolve(resData);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 开始轮询
    startPolling() {
      if (this.tableData.length == 0) {
        const types = ["COMPANY_INCORPORATION", "SERVICE_TRANSFER", "ADJUSTMENT"];
        if (types.includes(this.orderDetail.businessType)) {
          this.updateTipe = 2;
        } else {
          this.updateTipe = 1;
          // 定时器检查订单列表
          this.timerst = setInterval(() => {
            if (this.timerstNum >= 10) {
              this.clearTimer();
              this.updateTipe = 2;
            } else {
              this.timerstNum += 1;
              // 获取订单列表
              this.getOrderList();
            }
          }, 2000);
        }
      }
    },
    // 去支付
    payment(row) {
      const query = {
        orderId: row.id,
      };
      // 面包屑会用到applymentId/adjustmentId
      if (this.applymentId) {
        query.applymentId = this.applymentId;
      } else {
        query.adjustmentId = this.adjustmentId;
      }
      this.$router.push({
        path: "/enroll/payment",
        query,
      });
    },
    // 退款发票跳转（Credit Invoice）- 新标签页打开
    toRefundedInvoice(invoiceNo) {
      const { href } = this.$router.resolve(`/invoice?invoiceNo=${invoiceNo}`);
      window.open(href, "_blank");
    },
    // 清除定时器
    clearTimer() {
      if (this.timerst) {
        clearInterval(this.timerst);
        this.timerst = null;
      }
    },
  },
  created() {
    const query = this.$route.query;
    if (query.applymentId) {
      this.applymentId = query.applymentId;
      this.pageInit(1);
    } else if (query.adjustmentId) {
      this.adjustmentId = query.adjustmentId;
      this.pageInit(2);
    } else {
      // 给出提示：缺少参数
      this.$message({
        message: this.$t("common.error.scarce"),
        type: "error",
        duration: 1000,
        onClose: () => {
          this.$router.replace("/");
        },
      });
    }
  },
  beforeDestroy() {
    this.clearTimer();
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 170px);

  .messageTitle {
    border-radius: 2px;
    font-size: 16px;
    line-height: 1em;
    font-weight: 600;
  }

  .placeholderWrap {
    padding: 60px 0;

    img {
      width: 100px;
      height: 96px;
    }
  }

  .emptyTipe {
    font-size: 14px;
    color: #909399;
  }

  ::v-deep {
    .el-table__header {
      thead {
        tr {
          th {
            .cell {
              white-space: pre-line; // 换行符换行
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.refundedInvoiceDropdown {
  max-width: 350px;

  .el-dropdown-menu__item {
    white-space: normal; // 发票号过长时换行，而不是横向撑开
    word-break: break-all;
    line-height: 22px;
    padding: 3px 16px;
  }
}
</style>
